import { ALL_SLUGS } from '../parameters/clients'
import { DEFAULT_PROGRESS_STATE } from '../components/progress/constants'
import { OCODES_TYPE, SUBCODES } from '../services/types'
import { defaultParamsFitme } from '../parameters/defaultParamsFitme'

export const ALL_STATES = [
    'NONE',
    'AUTH',
    'INTRO',
    'HOW_TO_BINARY',
    'BRANDING',
    'RANK_14_X_BY_X',
    'RANK_FOR_PROFILE',
    'AWARD_ROUND',
    'RANK_FOR_ROUND',
    'HOW_TO_BUCKETS',
    'RANK_FOR_BUCKET',
    'FINAL_OVERVIEW',
    // 
    'ERROR',
    // 
    'HOW_TO_360',
    'PICKER_360',
    'PICKER_LEADERSHIP_360',
    'HOW_TO_WORKENV',
    'PICKER_WORKENV_360',
    'HOW_TO_NPS',
    'NPS_360',
    'THANKS_360',
    //
    'HOW_TO_Q_SORT',
    'QSORT_V2_RANKER',
] as const

export type FSM_STATE_TYPE = (typeof ALL_STATES)[number]
export type FSM_STATES_TYPE = Record<FSM_STATE_TYPE, FSM_STATE_TYPE>
export const FSM_STATES = ALL_STATES.reduce(
    (acc: any, current: FSM_STATE_TYPE) => {
        acc[current] = current
        return acc
    },
    {}
) as FSM_STATES_TYPE

export const DEFAULT_UI_STATE = {
    //  drawer
    top: false as boolean,
    left: false as boolean,
    bottom: false as boolean,
    right: false as boolean,
    showOverviewButton: false as boolean,
    // d&d
    deltaPosition: {
        x: 0 as number,
        y: 0 as number,
    },
} as const


export const DEFAULT_FSM_STEP = {
    topTitle: '' as string,
    currentScreenSubTitle: '' as string,
    nextLabel: 'NEXT' as string,
    nextAction: (() => {}) as any,
    prevLabel: 'PREV' as string,
    prevAction: (() => {}) as any,
    overrideTitle: '' as string,
    overrideSubTitle: '' as string,
} as const

export const DEFAULT_ASGN_STATE = {
    // STATE
    params: defaultParamsFitme,
    startedAt: (new Date()) as Date,
    // 
    fsmState: FSM_STATES.NONE as FSM_STATE_TYPE, //TODO no initial state when autologin()
    currentStmIndex: 0 as number, // index of the current statement)
    currentRound: 1 as number, // FIXME
    currentBucket: 1 as number,
    currentBucketRanking: 0 as number, // 0 means that the bucket is not ranked yet
    // FIXME migrate elsewhere
    error: null as [OCODES_TYPE, SUBCODES] | null
}
console.debug('DEFAULT_ASGN_STATE', DEFAULT_ASGN_STATE)
console.debug(DEFAULT_ASGN_STATE.startedAt.toISOString())

export const DEFAULT_AUTH_STATE = {
    token: '' as string,
    userEmail: '' as string,
    userId: '' as string,
    slug: '' as ALL_SLUGS,
    source: '' as string|undefined,
    from: '' as 'recruit' | 'talent' | 'staff'  |  string | undefined,
} as const

export const DEFAULT_GLOBAL_STATE = {
    ...DEFAULT_UI_STATE,
    ...DEFAULT_FSM_STEP,
    ...DEFAULT_PROGRESS_STATE,
    ...DEFAULT_AUTH_STATE
} as const

